export type ProductHighlightsProps = {
  detailRow: { name: string };
  vendorRow: { image?: string | null | undefined };
};

export function ProductHighlights({ detailRow, vendorRow }: ProductHighlightsProps) {
  return (
    <div className="flex items-center gap-4 border-b border-gray-200 mb-6 pb-4">
      <div className="flex-1">
        <h1 className="text-2xl font-bold text-gray-900 m-0">{detailRow.name}</h1>
      </div>
      {vendorRow.image && (
        <div className="flex-none flex items-center">
          <img alt="Product image" src={vendorRow.image} className="max-h-16 max-w-[160px] object-contain"/>
        </div>
      )}
    </div>
  );
}
